/* FATCUTPRESS Visual — FINE GRID / POINTER AFTERWAVE
 * No audio reaction. No checker. Pointer-only approved grid interaction.
 */
(()=>{'use strict';
const c=document.getElementById('fatcut-bg-grid'),R=window.FATCUT_VISUAL_REGISTRY;if(!c||!R)return;
const pointerEnabled=()=>document.body?.dataset.hasProducts!=='true';
const gl=c.getContext('webgl',{alpha:false,antialias:true,depth:false,stencil:false,preserveDrawingBuffer:false});if(!gl)return;
let active=false,raf=0,tx=innerWidth/2,ty=innerHeight/2,mx=tx,my=ty,target=0,strength=0;
const vs=`attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}`;
const fs=`precision highp float;
uniform vec2 r,m;uniform float t,strength,cells;
float line(float x,float w){float d=abs(fract(x)-.5);return 1.-smoothstep(w,w+1.2/r.y,d);}
void main(){
 vec2 uv=gl_FragCoord.xy/r,q=uv;float asp=r.x/r.y,tt=t*.20;
 q.x+=sin(uv.y*8.+tt*1.3)*.018+sin(uv.y*3.2-tt*.8)*.012;
 q.y+=sin(uv.x*7.-tt*1.1)*.017+sin(uv.x*3.6+tt*.7)*.010;
 vec2 mm=m/r;mm.y=1.-mm.y;vec2 d=uv-mm;d.x*=asp;float dist=length(d),f=exp(-dist*dist*18.);
 vec2 dn=dist>.0001?d/dist:vec2(0.);
 q+=vec2(dn.x/asp,dn.y)*f*.044*strength;
 float w1=sin(dist*22.-t*2.15)*exp(-dist*1.35)*.014;
 float w2=sin(dist*11.-t*1.25+1.7)*exp(-dist*.72)*.008;
 q+=vec2(dn.x/asp,dn.y)*(w1+w2)*strength;
 float gx=line(q.x*cells,.015),gy=line(q.y*cells/asp,.015),g=max(gx,gy);
 vec3 bg=vec3(.855,.840,.810);
 vec3 ink=vec3(.185,.195,.185);

 /* Approved background treatment:
    03B is the brightness ceiling; only the background drifts darker.
    Gradient level = 02 DEEPER. Grid line color stays fixed. */
 vec3 base=bg;
 vec2 p1=vec2(.15+.28*sin(t*.34), .22+.30*cos(t*.27));
 vec2 p2=vec2(.82+.24*cos(t*.25+1.4), .72+.27*sin(t*.32+2.0));
 vec2 p3=vec2(.48+.34*sin(t*.22+3.2), .80+.20*cos(t*.38));
 float b1=exp(-dot(uv-p1,uv-p1)*2.15);
 float b2=exp(-dot(uv-p2,uv-p2)*1.85);
 float b3=exp(-dot(uv-p3,uv-p3)*2.55);
 float broad=.5+.5*sin(uv.x*1.45-uv.y*.92+t*.35);
 float field=(b1*1.05-b2*.95+b3*.72+(broad-.5)*.82);
 float gradAmount=field*.20;
 float darken=max(0.0,-gradAmount)+max(0.0,gradAmount)*.38;
 float deep=darken+darken*darken*2.4;
 base=max(vec3(0.0),base-vec3(deep*.98,deep*1.02,deep*1.06));

 gl_FragColor=vec4(mix(base,ink,g*.72),1.);
}`;
function S(type,src){const s=gl.createShader(type);gl.shaderSource(s,src);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS)){console.warn('[FATCUT GRID]',gl.getShaderInfoLog(s));return null}return s}
const v=S(gl.VERTEX_SHADER,vs),f=S(gl.FRAGMENT_SHADER,fs);if(!v||!f)return;const p=gl.createProgram();gl.attachShader(p,v);gl.attachShader(p,f);gl.linkProgram(p);if(!gl.getProgramParameter(p,gl.LINK_STATUS))return;gl.useProgram(p);
const b=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,b);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,1,-1,-1,1,-1,1,1,-1,1,1]),gl.STATIC_DRAW);
const a=gl.getAttribLocation(p,'p');gl.enableVertexAttribArray(a);gl.vertexAttribPointer(a,2,gl.FLOAT,false,0,0);
const U=n=>gl.getUniformLocation(p,n),ur=U('r'),um=U('m'),ut=U('t'),us=U('strength'),uc=U('cells');
function resize(){const d=Math.min(devicePixelRatio||1,2);c.width=Math.max(1,Math.floor(innerWidth*d));c.height=Math.max(1,Math.floor(innerHeight*d));gl.viewport(0,0,c.width,c.height)}resize();addEventListener('resize',resize,{passive:true});
function setPointer(e){
  if(!active||!pointerEnabled())return;
  const rr=c.getBoundingClientRect();
  const nx=Math.max(0,Math.min(1,(e.clientX-rr.left)/Math.max(1,rr.width)));
  const ny=Math.max(0,Math.min(1,(e.clientY-rr.top)/Math.max(1,rr.height)));
  tx=nx*c.width;
  ty=ny*c.height;
  target=1;
}
/* visual layers intentionally use pointer-events:none, so listen on window
   instead of the canvas itself. This matches the working C2+ interaction path. */
window.addEventListener('pointermove',setPointer,{passive:true});
window.addEventListener('pointerdown',setPointer,{passive:true});
window.addEventListener('pointerup',()=>{target=0},{passive:true});
window.addEventListener('pointercancel',()=>{target=0},{passive:true});
window.addEventListener('mouseout',e=>{if(!e.relatedTarget&&!e.toElement)target=0});
window.addEventListener('blur',()=>{target=0});
function frame(ms){if(!active){raf=0;return}if(!pointerEnabled())target=0;mx+=(tx-mx)*.12;my+=(ty-my)*.12;strength+=(target-strength)*(target>strength?.10:.018);if(strength<.0005&&target===0)strength=0;
gl.uniform2f(ur,c.width,c.height);gl.uniform2f(um,mx,my);gl.uniform1f(ut,ms*.001);gl.uniform1f(us,strength);gl.uniform1f(uc,innerWidth<=749?12.0:22.0);gl.drawArrays(gl.TRIANGLES,0,6);raf=requestAnimationFrame(frame)}
const adapter={activate(){active=true;c.hidden=false;c.style.transition='opacity .95s cubic-bezier(.4,0,.2,1)';c.style.opacity='1';if(!raf)raf=requestAnimationFrame(frame)},deactivate(){active=false;target=0;c.style.transition='opacity .95s cubic-bezier(.4,0,.2,1)';c.style.opacity='0';if(raf){cancelAnimationFrame(raf);raf=0}},update(){}};
R.add('fine_grid_pointer',adapter);R.flush();
})();